import { render, staticRenderFns } from "./CreatePromotionCodeModal.vue?vue&type=template&id=82440858"
import script from "./CreatePromotionCodeModal.vue?vue&type=script&lang=js"
export * from "./CreatePromotionCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports